@if (initialized) {
    <div class="cn-import-container surface-0">

        <!-- Provisions-Import body (P3): Gesellschaft selection, import-method chooser
             (Lokaler KI-Agent / Strukturierte Datei / Manuell) and — for "Lokaler KI-Agent" —
             the generated, copyable prompt. All of that orchestration lives in the hosted
             CnImportStartComponent (mvs-cn-import-start). The page shell owns the routed
             skeleton + header. -->
        <mvs-cn-import-start></mvs-cn-import-start>

    </div>
}
